import { clsx } from 'clsx';
import type { StatutDeneignement } from '@/types';
import { STATUT_LABELS, STATUT_COLORS } from '@/types';

interface StatusBadgeProps {
  statut: StatutDeneignement;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Badge affichant le statut d'une intervention
 * Couleurs definies selon le SFD (section 8.1)
 */
export function StatusBadge({ statut, size = 'md', className }: StatusBadgeProps) {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };

  return (
    <span
      className={clsx(
        'inline-flex items-center font-medium rounded-full text-white',
        STATUT_COLORS[statut],
        sizeClasses[size],
        className
      )}
    >
      {STATUT_LABELS[statut]}
    </span>
  );
}

export default StatusBadge;
